import { render, staticRenderFns } from "./AumentoSueldo.vue?vue&type=template&id=6ff093a6"
import script from "./AumentoSueldo.vue?vue&type=script&lang=js"
export * from "./AumentoSueldo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports